<app1-header [hidden]="!ifLoggedIn()"></app1-header>

<div class="fxs-portal-main" [hidden]="!ifLoggedIn()">
    <div class="rectangle-2 sidebar">
        <app1-sidebar></app1-sidebar>
    </div>
    <div>

        <div class="MainContainer">

            <router-outlet>
                <app-loader></app-loader>
            </router-outlet>

        </div>
    </div>
</div>

<app-footer *ngIf="ifLoggedIn()"></app-footer>